import React from 'react';

export default function Component(props) {

const { question, answersList,handleRadio} = props;

return(
    <>
      <div className="grid md:grid-cols-7 grid-cols-7  py-6  lg:text-base text-sm font-normal  mb-4 gap-3 mx-2">
        {question && question.optionsList && question.optionsList.length>0?
          question.optionsList.map((option, optionindex) =>

          ((answersList && answersList.length > 0 && answersList.findIndex(item => item.questionId === question.id) !== -1) ?
            answersList[answersList.findIndex(item => item.questionId === question.id)].answer: '')?
                (option.name<=answersList[answersList.findIndex(item => item.questionId === question.id)].answer)?
                <div onClick={() => handleRadio(optionindex, question, option)}  className="px-2 cursor-pointer">
                  <img src="img/questiontype/star/svg/ion_star-sharp-white.svg" style={{width:"60px",height:'60px'}} alt="star"/>
                  </div>
                :
                <div onClick={() => handleRadio(optionindex, question, option)}  className="px-2 cursor-pointer">
                  <img src="img/questiontype/star/svg/el_star-empty-white.svg" style={{width:"60px",height:'60px'}} alt="emptystar" />
                  </div>

              :
              <div onClick={() => handleRadio(optionindex, question, option)}  className="px-2 cursor-pointer">
                <img src="img/questiontype/star/svg/el_star-empty-white.svg" style={{width:"60px",height:'60px'}} alt="emptystar"/>
                </div>
        ):null}
      </div>
    </>
  );}